import AES from 'crypto-js/aes';
import Base64 from 'crypto-js/enc-base64';
import ECB from 'crypto-js/mode-ecb';
import Pkcs7 from 'crypto-js/pad-pkcs7';

const GUEST_ACCESS_PLAINTEXT = 'allroomie-guest';
const GUEST_ACCESS_AES_KEY_BASE64 = 'r5fYH7Wk0D7P6Wzq4m4mQ1H8hP5Qq2o6hV4c9JwL8m8=';
const JWT_AUTH_REQUIRED_MARKER = 'jwt-auth-required';

const encryptGuestAccessValue = (): string => {
  const key = Base64.parse(GUEST_ACCESS_AES_KEY_BASE64);
  const encrypted = AES.encrypt(GUEST_ACCESS_PLAINTEXT, key, {
    mode: ECB,
    padding: Pkcs7,
  });

  return encrypted.ciphertext.toString(Base64);
};

const ENCRYPTED_GUEST_ACCESS_VALUE = encryptGuestAccessValue();

/**
 * The gateway requires this header on both guest and authenticated chat requests.
 * A decryptable value enables guest access; an intentionally undecryptable value
 * makes the gateway continue through its normal JWT validation path.
 */
export const getGatewayEncryptedData = (token: string | null): string =>
  token ? JWT_AUTH_REQUIRED_MARKER : ENCRYPTED_GUEST_ACCESS_VALUE;
